import { system } from 'styled-system';
var config = {
    whiteSpace: true,
};
export default system(config);
//# sourceMappingURL=whitespace.js.map